var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"SSOSignInView"},[_c('h1',{staticClass:"title-page mb-12"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.title)}})]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }